export const addList = ({
  item,
  setList,
  list,
}: {
  item: any;
  setList: Function;
  list: Array<Object>;
}) => {
  setList([...list, item]);
};

export const editList = ({
  item,
  setList,
  list,
  index,
}: {
  item: any;
  setList: Function;
  list: Array<Object>;
  index: number;
}) => {
  list[index] = item;
  setList(list);
};

export const removeList = ({
  setList,
  list,
  index,
}: {
  setList: Function;
  list: Array<Object>;
  index: number;
}) => {
  list.splice(index, 1);
  setList(list);
};
